import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatAccordion } from '@angular/material/expansion';
import { MatTableDataSource } from '@angular/material/table';
import { ProcessComponent } from '../process/process.component';
import { roleModel, RoleService } from './dummy-role-item';


@Component({
    selector: 'app-role',
    templateUrl: './role.component.html',
    styleUrls: ['./role.component.less'],
    standalone: false
})
export class RoleComponent implements AfterViewInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  myForm: FormGroup;
  permissionCol: any[] = [
    { id: 'processName', name: 'Process' },
    { id: 'permission', name: 'General Permission' },
    { id: 'add', name: 'Add' },
    { id: 'edit', name: 'Edit' },
    { id: 'view', name: 'View' },
    { id: 'delete', name: 'Delete' },
  ];
  permissionColumn: string[] = this.permissionCol.map(col => col.id);
  filterValues = {
    processName: ""
  };
  _selectedRoles = this.service.roleList.filter(function (key) {
    return key["selected"] == true;
  })
  dataSource = new MatTableDataSource<roleModel>(this._selectedRoles);
  constructor(public dialog: MatDialog, private service: RoleService, public fb: FormBuilder) {
    this.dataSource.filterPredicate = this.createFilter();
  }
  ngOnInit(): void {
    this.reactiveForm();
  }
  reactiveForm() {
    this.myForm = this.fb.group({
      processFilter: [null]
    })
  }
  ngAfterViewInit(): void {
    this.myForm.controls.processFilter.valueChanges.subscribe(processName => {
      this.filterValues.processName = String(processName).toLowerCase();
      this.dataSource.filter = JSON.stringify(this.filterValues);
    });
  }
  createFilter(): (dataList: roleModel, filter: string) => boolean {
    let filterFunction = function (dataList, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return (
        dataList.processName.toLowerCase().indexOf(searchTerms.processName) !== -1
      );
    };
    return filterFunction;
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    this.dialog.open(ProcessComponent).afterClosed().subscribe(result => {
      if (result != "close") {
        this.service.roleList = result;
        let _selectedRoles = this.service.roleList.filter(function (key) {
          return key["selected"] == true;
        })
        this.dataSource = new MatTableDataSource<roleModel>(_selectedRoles);
      }
      console.log(`Dialog result: ${result}`);
    });
  }

}
